import React from "react";
var __jsx = React.createElement;
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import InputToPopUp from "@/pages/serviceCenters/ServiceCentersComponents/InputToPopUp/InputToPopUp";
import SearchSVG from "../../../../../../components/UiKit/UiKitSVGs/SearchSVG";
import DownArrowSVG from "../../../../../../components/UiKit/UiKitSVGs/DownArrowSVG";
import SCPopUp from "../SCPopUp/SCPopUp";
import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./SCFiltersHeader.module.css";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
var SCFiltersHeader = function SCFiltersHeader(_ref) {
  var _filters$make_id, _filters$make_id2, _filters$make_id3, _filters$city_id, _filters$city_id2, _filters$city_id3, _filters$dealership_n, _filters$dealership_n2, _popUpData$data;
  var filters = _ref.filters,
    availableSCData = _ref.availableSCData,
    onFiltersChange = _ref.onFiltersChange,
    showPopUp = _ref.showPopUp,
    setShowPopUp = _ref.setShowPopUp,
    onSingleFilterChange = _ref.onSingleFilterChange,
    popUpData = _ref.popUpData,
    loading = _ref.loading;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(["web_service_centers"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.SCFiltersContainer
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("service_centers", {
        ns: "web_common"
      })
    }]
  }), /*#__PURE__*/React.createElement("h1", null, t("service_centers", {
    ns: "web_service_centers"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.SCFiltersOpt
  }, (filters === null || filters === void 0 ? void 0 : (_filters$make_id = filters.make_id) === null || _filters$make_id === void 0 ? void 0 : _filters$make_id.name) === "" || loading ? /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 50,
    numberOfLoaders: 3
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputToPopUp, {
    key: "make_id",
    onInputClick: function onInputClick() {
      onSingleFilterChange("make_id", t("car_make", {
        ns: "web_service_centers"
      }), t("look_brand", {
        ns: "web_service_centers"
      }), t("car_make", {
        ns: "web_service_centers"
      }), filters.make_id.name, availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.makes, function (v) {
        onFiltersChange("make_id", v.name, v.key);
        setShowPopUp(false);
      }, 1);
      setShowPopUp(true);
    }
  }, /*#__PURE__*/React.createElement(SearchSVG, {
    filledColor: (filters === null || filters === void 0 ? void 0 : (_filters$make_id2 = filters.make_id) === null || _filters$make_id2 === void 0 ? void 0 : _filters$make_id2.name) !== "" ? "#154F9C" : "#B7C0C9"
  }), /*#__PURE__*/React.createElement("p", null, filters === null || filters === void 0 ? void 0 : (_filters$make_id3 = filters.make_id) === null || _filters$make_id3 === void 0 ? void 0 : _filters$make_id3.name)), /*#__PURE__*/React.createElement(InputToPopUp, {
    key: "city_id",
    onInputClick: function onInputClick() {
      onSingleFilterChange("city_id", t("city", {
        ns: "web_service_centers"
      }), t("choose_city", {
        ns: "web_service_centers"
      }), t("city", {
        ns: "web_service_centers"
      }), filters.city_id.name, availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.cities, function (v) {
        onFiltersChange("city_id", v.name, v.key);
        setShowPopUp(false);
      }, 1);
      setShowPopUp(true);
    },
    errorMsg: (availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.cities.length) <= 0 && t("there_service_centers_city", {
      ns: "web_service_centers"
    })
  }, /*#__PURE__*/React.createElement(SearchSVG, {
    filledColor: (filters === null || filters === void 0 ? void 0 : (_filters$city_id = filters.city_id) === null || _filters$city_id === void 0 ? void 0 : _filters$city_id.name) !== "" ? "#154F9C" : "#B7C0C9"
  }), filters !== null && filters !== void 0 && (_filters$city_id2 = filters.city_id) !== null && _filters$city_id2 !== void 0 && _filters$city_id2.name ? /*#__PURE__*/React.createElement("p", null, filters === null || filters === void 0 ? void 0 : (_filters$city_id3 = filters.city_id) === null || _filters$city_id3 === void 0 ? void 0 : _filters$city_id3.name) : /*#__PURE__*/React.createElement("p", {
    className: stl.grayColor
  }, t("choose_city", {
    ns: "web_service_centers"
  }))), /*#__PURE__*/React.createElement(InputToPopUp, {
    key: "dealership_name",
    onInputClick: function onInputClick() {
      onSingleFilterChange("dealership_name", t("dealership", {
        ns: "web_service_centers"
      }), t("dealership", {
        ns: "web_service_centers"
      }), t("dealership", {
        ns: "web_service_centers"
      }), filters.dealership_name.name, availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.wakalat, function (v) {
        onFiltersChange("dealership_name", v.name, v.key);
        setShowPopUp(false);
      }, 1);
      setShowPopUp(true);
    },
    className: "".concat(stl.spaceBetween, " ").concat((availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.wakalat.length) <= 0 ? stl.disabled : ""),
    errorMsg: filters.city_id.value !== "" && (availableSCData === null || availableSCData === void 0 ? void 0 : availableSCData.wakalat.length) <= 0 && t("there_service_centers_dealership", {
      ns: "web_service_centers"
    })
  }, filters !== null && filters !== void 0 && (_filters$dealership_n = filters.dealership_name) !== null && _filters$dealership_n !== void 0 && _filters$dealership_n.name ? /*#__PURE__*/React.createElement("p", null, filters === null || filters === void 0 ? void 0 : (_filters$dealership_n2 = filters.dealership_name) === null || _filters$dealership_n2 === void 0 ? void 0 : _filters$dealership_n2.name) : /*#__PURE__*/React.createElement("p", {
    className: stl.grayColor
  }, t("dealership", {
    ns: "web_service_centers"
  })), /*#__PURE__*/React.createElement(DownArrowSVG, null)))), /*#__PURE__*/React.createElement(SubmitButton, {
    className: stl.btn,
    onClick: function onClick() {
      document.location = createUrl("/service-centers");
    }
  }, t("reset", {
    ns: "web_service_centers"
  }))), (popUpData === null || popUpData === void 0 ? void 0 : (_popUpData$data = popUpData.data) === null || _popUpData$data === void 0 ? void 0 : _popUpData$data.length) > 0 ? /*#__PURE__*/React.createElement(SCPopUp, {
    popUpData: popUpData,
    setShowPopUp: setShowPopUp,
    showPopUp: showPopUp
  }) : null);
};
export default SCFiltersHeader;